import { environment } from '@environments/environment';

export function isWeb3Auth(): boolean {
  return environment['USE_WEB_3_AUTH'] === 'true';
}
